import React from "react";

export const useResponseTimer = (responseId: string) => {
  const [elapsedSeconds, setElapsedSeconds] = React.useState(0);
  const startTimeRef = React.useRef<number>(Date.now());

  // Reset timer when response changes
  React.useEffect(() => {
    setElapsedSeconds(0);
    startTimeRef.current = Date.now();
  }, [responseId]);

  // Update elapsed time every second
  React.useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
      setElapsedSeconds(elapsed);
    }, 1000);

    return () => clearInterval(interval);
  }, [responseId]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const getTimerColor = (seconds: number): string => {
    if (seconds >= 180) return "text-destructive"; // Red after 3 minutes
    if (seconds >= 120) return "text-orange-500"; // Orange after 2 minutes
    return "text-muted-foreground"; // Default gray
  };

  return {
    elapsedSeconds,
    formattedTime: formatTime(elapsedSeconds),
    timerColor: getTimerColor(elapsedSeconds),
  };
};
